import { render, staticRenderFns } from "./robotBatchSetup.vue?vue&type=template&id=8914391e&scoped=true&"
import script from "./robotBatchSetup.vue?vue&type=script&lang=js&"
export * from "./robotBatchSetup.vue?vue&type=script&lang=js&"
import style0 from "./robotBatchSetup.vue?vue&type=style&index=0&id=8914391e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8914391e",
  null
  
)

export default component.exports